import React, { memo } from 'react';
import Grid from '~/shared/components/Grid';
import Modal from '~/shared/components/Modal';
import { ImageItems } from '../ImageItems';
import { PDPMediaContainer } from './styled';
import { Image } from '~/features/product-details-page/pdp.definitions';
import dynamic from 'next/dynamic';
import { Video } from '~/shared/components';

type Props = {
    className?: string;
    asGallery?: boolean;
    images: Image[];
    videos?: string[];
    selectedImageIndex?: number;
    onClick?: (index?: number) => void;
    name?: string;
    thumbnailUrl?: string;
    onToggleGallery?: () => void;
};

const ImageGallery = dynamic(() => import('~/shared/components/ImageGallery'), {
    ssr: false,
});

export const PDPMedia = ({
    asGallery,
    images,
    selectedImageIndex,
    onClick,
    videos,
    name,
    thumbnailUrl,
    onToggleGallery,
}: Props) => {
    const columns = images?.length > 1 ? '1fr 1fr' : '1fr';
    return (
        <PDPMediaContainer>
            {asGallery && (
                <Modal
                    variant="gallery"
                    isOpen
                    showCloseIcon
                    handleClose={() => onToggleGallery?.()}
                >
                    <ImageGallery images={images} selectedIndex={selectedImageIndex} />
                </Modal>
            )}

            <Grid flow="row" columns={columns} columnGap="small" rowGap="small">
                <ImageItems
                    images={images}
                    onClick={(index) => {
                        onToggleGallery?.();
                        onClick?.(index);
                    }}
                />
                {videos?.map((video) => (
                    <div key={video} style={{ gridColumn: '1/3' }}>
                        <Video src={video} thumbnailUrl={thumbnailUrl} name={name} />
                    </div>
                ))}
            </Grid>
        </PDPMediaContainer>
    );
};

export default memo(PDPMedia);
